import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { TeachersHeader } from "./TeachersHeader";
import { EntitySectionLayout } from "@/shared/components/common/EntitySectionLayout";

/** Teachers list -> class mapping page, shown on the right of the breadcrumb. */
function ManageClassAssignmentsLink() {
  const { t } = useTranslation("teachers");
  return (
    <Link
      to="/teachers/class-mapping"
      className="inline-flex items-center gap-1.5 font-medium text-[var(--primary-blue)] text-sm hover:underline"
    >
      {t("teachers:list.manageClassAssignments")}
      <ArrowRight className="w-4 h-4" aria-hidden />
    </Link>
  );
}

export function TeachersLayout() {
  const { pathname } = useLocation();
  // Only the teachers list gets the link (not add, edit, bulk upload or the mapping page itself).
  const isListPage = /^\/teachers\/?$/.test(pathname);

  return (
    <EntitySectionLayout
      basePath="/teachers"
      HeaderComponent={TeachersHeader}
      hideHeaderMatchers={["add-teachers", "edit/", "class-mapping"]}
      breadcrumbAction={isListPage ? <ManageClassAssignmentsLink /> : undefined}
    />
  );
}
